import * as angular from "angular";
import {IController} from "angular";
import {Settelment} from "../../models/settelment.model";
import * as _ from "lodash";
import {ContractPriceType} from "../../types/contract-price.type";
import {ContractPriceMethodType} from "../../types/contract-price-method.type";


export class CreateContractDialogCtrl implements IController {
  form: any;
  contractName: string;
  settlementsArray: Settelment[];
  onAddSettlement: Function;
  onDeleteSettlement: Function;
  onSetProgramType: Function;
  onChanges: Function;


  public contractPriceType: ContractPriceType[];
  public contractPriceMethodTypes: ContractPriceMethodType[];
  public usedProgramTypesMap: any;
  public availablePriceTypesByMethod: any;

  private readonly siteProgramTypes: any[];

  constructor(private splitService, private contractsConstants) {
    this.contractPriceMethodTypes = Object.values(ContractPriceMethodType);
    this.siteProgramTypes = splitService.getSiteProgramTypes();
    this.usedProgramTypesMap = {}
    this.availablePriceTypesByMethod = contractsConstants.availableContractPriceTypesByMethod;
  }

  $onInit() {
  }

  setDisabledMap(selectedProgramId) {
    this.usedProgramTypesMap = {};
    _.forEach(this.siteProgramTypes, (siteProgram) => {
      const selectedProgram = _.find(this.settlementsArray, (settlement) => {
        return settlement.programType === siteProgram.id;
      })
      this.usedProgramTypesMap[siteProgram.id] = !!selectedProgram && (selectedProgramId !== selectedProgram.programType);
    })
  }

  onPriceRangeChanged(programSetting) {
    _.unset(programSetting, 'priceType');
    this.onChanges({contractName: this.contractName, settlementsArray: this.settlementsArray});
  }


}

angular
  .module('bringoz.admin.contracts')
  .component('createContractDialog', {
    require: {
      form: '^form'
    },
    bindings: {
      settlementsArray: '<',
      contractName: '<',
      onAddSettlement: '&',
      onDeleteSettlement: '&',
      onSetProgramType: '&',
      onChanges: '&'
    },
    template: require('./create-contract-dialog.html').default,
    controller: CreateContractDialogCtrl
  });
